var _linearGradient, _linearGradient2, _linearGradient3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 700.002,
    height: 661.276,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: -86.77,
    x2: 348.738,
    y1: 1755.67,
    y2: 1755.67,
    gradientTransform: "translate(-191.492 -56.85)",
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#892f2f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#892f2f",
      stopOpacity: 0
    }
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "e",
    x1: 1823.802,
    x2: -49.513,
    y1: 1660.591,
    y2: -433.848,
    gradientUnits: "userSpaceOnUse"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    style: {
      stopColor: "#047fa3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#07c1f5",
      stopOpacity: 0
    }
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "d",
    x1: 1823.802,
    x2: -49.513,
    y1: 1660.591,
    y2: -433.848,
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M157.246 1698.82a217.754 217.754 0 0 1-215.943 217.747 217.754 217.754 0 0 1-219.534-214.126 217.754 217.754 0 0 1 212.294-221.306 217.754 217.754 0 0 1 223.063 210.447",
    style: {
      opacity: 0.55,
      fill: "url(#c)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.89071
    },
    transform: "matrix(1.33995 0 0 1.33995 470.626 -1906.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.925 981.394c46.953 1148.128 1219.001-413.681 96.945-165.908-4221.132 932.116 2991.357-2019.655-660.874 292.919-970.832 614.726 967.759 848.845 192.152 1.002-2917.801-3189.55 3244.752 1580.764-584.111-425.874-1017.784-533.402-251.242 1262.526 95.208 166.91 1303.33-4121.665 253.394 3600.42 76.762-718.793-46.952-1148.127-1219 413.682-96.945 165.908C4498.194-634.557-2714.295 2317.214 937.936 4.64c970.832-614.726-967.759-848.845-192.152-1.003 2917.801 3189.55-3244.752-1580.764 584.112 425.875 1017.783 533.402 251.241-1262.527-95.208-166.91-1303.33 4121.664-253.395-3600.42-76.763 718.792Z",
    style: {
      opacity: 0.23,
      fill: "url(#d)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.69795
    },
    transform: "matrix(.24759 -.2005 .19471 .24045 51.994 344.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.925 981.394c46.953 1148.128 1219.001-413.681 96.945-165.908-4221.132 932.116 2991.357-2019.655-660.874 292.919-970.832 614.726 967.759 848.845 192.152 1.002-2917.801-3189.55 3244.752 1580.764-584.111-425.874-1017.784-533.402-251.242 1262.526 95.208 166.91 1303.33-4121.665 253.394 3600.42 76.762-718.793-46.952-1148.127-1219 413.682-96.945 165.908C4498.194-634.557-2714.295 2317.214 937.936 4.64c970.832-614.726-967.759-848.845-192.152-1.003 2917.801 3189.55-3244.752-1580.764 584.112 425.875 1017.783 533.402 251.241-1262.527-95.208-166.91-1303.33 4121.664-253.395-3600.42-76.763 718.792Z",
    style: {
      opacity: 1,
      fill: "url(#e)",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 4.69795
    },
    transform: "matrix(.12564 -.10174 .0988 .12201 205.947 331.983)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.86392602e5772721de4731819dd20e7a.svg";
export { ForwardRef as ReactComponent };